import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { BrandMark, Wordmark } from "../components/common/Brand";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim(), password.trim());
      toast.success("Welcome back, Tricia.");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-ivory" data-testid="page-admin-login">
      <div className="hidden lg:flex flex-col justify-between bg-nightsky text-ivory p-12 relative">
        <div className="flex items-center gap-3">
          <BrandMark size={48} />
          <Wordmark className="text-xl text-ivory" />
        </div>
        <div>
          <div className="star-sep mb-6"><span>Advisor Portal</span></div>
          <p className="font-serif text-4xl lg:text-5xl leading-[1.1] text-ivory">
            Welcome back, <span className="italic text-gold">Chief Escape Artist.</span>
          </p>
          <p className="mt-6 text-ivory/60 text-sm font-light max-w-md">Manage travel inquiries and messages from your clients in one elegant place.</p>
        </div>
        <div className="text-[11px] uppercase tracking-[0.3em] text-ivory/40">© LuxeTini Escapes</div>
      </div>

      <div className="flex items-center justify-center p-8 lg:p-20">
        <form onSubmit={onSubmit} className="w-full max-w-md" data-testid="admin-login-form">
          <div className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Sign In</div>
          <h1 className="font-serif text-5xl mb-10 text-ink">Advisor Portal</h1>

          <div className="space-y-8">
            <div>
              <label className="text-xs uppercase tracking-[0.24em] text-muted mb-2 block">Email</label>
              <input className="field-editorial" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.24em] text-muted mb-2 block">Password</label>
              <input className="field-editorial" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
            </div>
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="mt-10 w-full inline-flex items-center justify-center gap-2 h-14 bg-ink text-ivory hover:bg-teal transition-colors text-[12px] uppercase tracking-[0.28em] disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {submitting ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
